import { createContext } from "react";

type PortalContainerContext = { container: HTMLDivElement | null };

export const PortalContainerContext = createContext<PortalContainerContext>({
  container: null,
});
